/**
 * History API Proxy
 * Patches pushState and replaceState to ensure Barba's state is preserved
 * when other scripts (like ALM Filters) try to overwrite it.
 */
export function patchHistoryStateForBarba() {
    // Guard against double-wrapping. If the bundle is evaluated more than once
    // (HMR in dev, or a script re-importing this entry), re-patching would make
    // every navigation merge state twice and could recurse through prior wrappers.
    if (history.pushState.__barbaStatePatched) return;

    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function(state, title, url) {
        const currentState = history.state || {};
        const newState = Object.assign({}, currentState, state);
        return originalPushState.apply(this, [newState, title, url]);
    };
    history.pushState.__barbaStatePatched = true;

    history.replaceState = function(state, title, url) {
        const currentState = history.state || {};
        const newState = Object.assign({}, currentState, state);
        return originalReplaceState.apply(this, [newState, title, url]);
    };
    history.replaceState.__barbaStatePatched = true;
}
